import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import './input-number-with-counter.scss';
import clsx from 'clsx';
import { Minus, Plus } from 'react-feather';
import Input, { InputTypes } from '../input/input';
import Icon, { IconColors, IconSizes } from '../icon';
import Button, { ButtonSizes, ButtonTypes } from '../button';

const InputNumberWithCounterActions = {
  INCREMENT: 'increment',
  DECREMENT: 'decrement',
};

const InputNumberWithCounter = (
  {
    label,
    className,
    value,
    min,
    max,
    prefixAction,
    suffixAction,
    step = 1,
    onChange,
  },
) => {
  const [input, setInput] = useState(value);

  const handleCounter = (action) => {
    const changeBy = action === InputNumberWithCounterActions.INCREMENT ? step : -step;
    const updatedValue = Number.isNaN(input) || input === '' ? 1 : input + changeBy;
    if (updatedValue >= min && updatedValue <= max) {
      setInput(updatedValue);
      onChange?.({
        target: { value: updatedValue, valueAsNumber: updatedValue },
      });
    }
  };

  const renderIcon = useCallback(({ icon }) => (
    <Icon icon={icon} color={IconColors.GREY} size={IconSizes.SMALL} />
  ), []);

  const renderCounterButton = (action) => {
    let icon;
    if (action === InputNumberWithCounterActions.INCREMENT) {
      icon = Plus;
    } else {
      icon = Minus;
    }
    return (
      <Button
        type={ButtonTypes.LINK_SECONDARY}
        size={ButtonSizes.X_SMALL}
        renderIcon={() => renderIcon({ icon })}
        onClick={() => handleCounter(action)}
      />
    );
  };

  const handleChange = (e) => {
    const inpValue = e.target.valueAsNumber;
    setInput(inpValue);

    const event = {
      ...e,
      target: {
        ...e.target,
        value: inpValue,
      },
    };
    onChange(event);
  };

  return (
    <Input
      type={InputTypes.NUMBER}
      label={label}
      className={clsx(['input-number-with-counter', className])}
      max={max}
      min={min}
      value={input}
      onChange={handleChange}
      prefix={renderCounterButton(prefixAction)}
      suffix={renderCounterButton(suffixAction)}
    />
  );
};
InputNumberWithCounter.defaultProps = {
  label: '',
  className: '',
  value: '',
  min: 1,
  max: 100,
  prefixAction: InputNumberWithCounterActions.DECREMENT,
  suffixAction: InputNumberWithCounterActions.INCREMENT,
  step: 1,
  onChange: () => {},
};

InputNumberWithCounter.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  min: PropTypes.number,
  max: PropTypes.number,
  prefixAction: PropTypes.oneOf(Object.values(InputNumberWithCounterActions)),
  suffixAction: PropTypes.oneOf(Object.values(InputNumberWithCounterActions)),
  onChange: PropTypes.func,
  step: PropTypes.number,
};

export {
  InputNumberWithCounter as default,
  InputNumberWithCounterActions,
};
